import(/* webpackMode: "eager" */ "/home/u738178471/domains/palipaintsadmin.palicrafts.in/hbuilds/source/palipaint/src/app/page.tsx");
